<button
  mat-fab
  color="primary"
  class="fab fab-fixed-right"
  (click)="addPoi()"
  *ngIf="!itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <mat-icon>add</mat-icon>
</button>

<app-empty-list-message
  *ngIf="getPois().length == 0"
  message="Per questo giorno non è ancora stato inserito alcun luogo."
  actionIcon="add"
  actionLabel="Aggiungi un luogo"
  (actionClick)="addPoi()"
  [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <p>
    <small
      >La sezione “Luoghi da scoprire” può essere utilizzata per approfondire un
      punto di interesse particolare per cui non è stato sufficiente lo spazio
      della card “attività”.</small
    >
  </p>
  <p>
    <small
      >Utilizzare la sezione “Luoghi di interesse” per descrivere una
      particolarità, raccontare una storia, dare un consiglio di merito, che non
      si è avuto spazio per inserire in “attività”.</small
    >
  </p>
  <p>
    <small
      >Non inserire mai gli alloggi e sistemazioni nei “Luoghi da scoprire”,
      sono sufficienti le informazioni inserite nella sezione
      “Prenotazioni”.</small
    >
  </p>
</app-empty-list-message>

<mat-accordion>
  <mat-expansion-panel
    *ngFor="let poi of getPois(); index as poiId"
    [(expanded)]="expanded[poiId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <mat-icon class="header-icon">
          place
        </mat-icon>
        <span class="header-title" fxFlex>{{ poi.title }}</span>
        <div class="header-actions">
          <button
            mat-icon-button
            matTooltip="Rimuovi questo luogo"
            (click)="removePoi($event, poi)"
            *ngIf="
              !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
            "
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-itinerary-day-poi-form
      [poi]="poi"
      [poiId]="poiId"
      [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
    ></app-itinerary-day-poi-form>
  </mat-expansion-panel>
</mat-accordion>
